import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import axios from "axios";
import globalVariables from "../../global-variables";
import Metatag from '../../hooks/Metatag'
export default function ContactUs() {
    const [toggler, setToggler] = useState(true);
    const [index, setIndex] = useState(0);
    const navigate = useNavigate();
    
    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    useEffect(() => {
        // add class for home header and remove inner class
        $(".fixed-top").addClass("bg-header");

        


    }, []);
   
    const [setting, setSettingList] = useState([]);

    useEffect(() => {
        let _obj = new Object();
        _obj.setting_id = global.variables.strSetting_id;
        axios.post(global.variables.strApiUrl + "/settingApi/getCompanySettingList", _obj)
            .then((response_list) => {
                if(response_list.data === 'error')
                {
                    navigate('/error-page')
                }
                else
                {
                    // pass the result in the success function of the respective page
                    setSettingList(response_list.data[0]);
                }
            });
    }, [])

    useEffect(()=>{
        // initiate the wow effect
        new WOW.WOW({
            live: false,
        }).init();
    },[setting])
    
    return (
        <>
            <Header main_className="bg-header"></Header>

            {/* Metatag  */}
            <Metatag title='National Disease Modelling Consortium at IIT Bombay '
                    keywords='NDMC at Indian Institute of Technology Bombay, NDMC Contact Details, NDMC Location, NDMC Location Map, Disease Modelling Academic Training Programmes in India, Disease Modelling Workshops in India, Disease Modelling Conferences in India' 
                    description='National Disease Modelling Consortium is located at Indian Institute of Technology Bombay offering Disease Modelling by expert Modellers.'
                    />

            <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('./images/bg-contact.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
                <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
                <div className="masthead d-flex align-items-center w-100">
                    <Container className="px-4 px-md-5">
                        <h1 className="mb-0 fw-bold text-white text-uppercase pb-xl-5 py-4">Contact Us</h1>
                    </Container>
                </div>
            </Container>

            <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">

                <Row className="align-items-center">
                    <Col md="6">
                        {
                            setting[0]?.setting_company != undefined ?
                            <h3 className="text-danger fw-bold m-0 wow fadeInUp">{setting[0]?.setting_company}</h3>
                            :
                            null

                        }
                        {
                            setting[0]?.setting_address != undefined ?
                            <p>{setting[0]?.setting_address}<br />{`${setting[0]?.setting_city} ${setting[0]?.setting_pin}. ${setting[0]?.setting_country}`}.</p>
                            :
                            null
                        }
                        <p><b>E:</b> <Link to="mailto:ndmc.iitb@gmail.com">{setting[0]?.setting_contact_email}</Link><br />
                            <b>T:</b> {setting[0]?.setting_phone}</p>
                    </Col>
                    <Col md="6">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.406813974157!2d72.91231631493856!3d19.133661805129535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c7f6103d54a9%3A0xe4ee7b506fa87833!2sDepartment%20of%20Mathematics!5e0!3m2!1sen!2sin!4v1675684216093!5m2!1sen!2sin" width="100%" height="300"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" className="rounded-3 border"></iframe>
                    </Col>
                </Row>


            </Container >


            {/* Breadcrumb */}
            <Container Container fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto" >
                <Breadcrumb>
                    <Breadcrumb.Item href={globalVariables.variables.strDomainUrl}>Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>Contact Us</Breadcrumb.Item>
                </Breadcrumb>
            </Container>
            {/* Breadcrumb */}
        </>
    );
}